var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-wizard-dialog", {
    attrs: {
      title: _vm.$gettext("Aufgabe verteilen"),
      confirmText: _vm.$gettext("Verteilen"),
      closeText: _vm.$gettext("Abbrechen"),
      lastRequiredSlotId: 6,
      requirements: _vm.requirements,
      slots: _vm.wizardSlots,
    },
    on: {
      close: function close($event) {
        return _vm.setShowTasksDistributeDialog(false)
      },
      confirm: _vm.distributeTask,
    },
    scopedSlots: _vm._u([
      {
        key: "sourceunit",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm.sourceUnits.length !== 0
                  ? _c(
                      "fieldset",
                      {
                        staticClass: "radiobutton-set",
                      },
                      [
                        _vm._l(_vm.sourceUnits, function (unit) {
                          var _domProps

                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedSourceUnit,
                                  expression: "selectedSourceUnit",
                                },
                              ],
                              key: "radio-" + unit.id,
                              attrs: {
                                id: "cw-task-dist-source-unit" + unit.id,
                                type: "radio",
                                "aria-description":
                                  unit.element.attributes.title,
                              },
                              domProps:
                                ((_domProps = {
                                  checked: unit.id === _vm.selectedSourceUnitId,
                                  value: unit,
                                }),
                                (_domProps["checked"] = _vm._q(
                                  _vm.selectedSourceUnit,
                                  unit
                                )),
                                _domProps),
                              on: {
                                change: function change($event) {
                                  _vm.selectedSourceUnit = unit
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                key: "label-" + unit.id,
                                attrs: {
                                  for: "cw-task-dist-source-unit" + unit.id,
                                },
                                on: {
                                  click: function click($event) {
                                    _vm.selectedSourceUnit = unit
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "icon",
                                  },
                                  [
                                    _c("studip-icon", {
                                      attrs: {
                                        shape: "courseware",
                                        size: 32,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(unit.element.attributes.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("studip-icon", {
                                  staticClass: "unchecked",
                                  attrs: {
                                    shape: "radiobutton-unchecked",
                                    size: 24,
                                  },
                                }),
                                _vm._v(" "),
                                _c("studip-icon", {
                                  staticClass: "check",
                                  attrs: {
                                    shape: "check-circle",
                                    size: 24,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    )
                  : _c("courseware-companion-box", {
                      attrs: {
                        mood: "sad",
                        msgCompanion: _vm.$gettext(
                          "Es stehen keine Lernmaterialien zur Verfügung."
                        ),
                      },
                    }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "task",
        fn: function fn() {
          return [
            _vm.selectedSourceUnit
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "fieldset",
                      {
                        staticClass: "radiobutton-set",
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "cw-task-dist-task",
                            type: "radio",
                            "aria-description": _vm.selectedTaskTitle,
                          },
                          domProps: {
                            checked: _vm.selectedTaskIsTask,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            attrs: {
                              for: "cw-task-dist-task",
                            },
                            on: {
                              click: function click(e) {
                                return e.preventDefault()
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "icon",
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "content2",
                                    size: "32",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                              },
                              [_vm._v(_vm._s(_vm.selectedTaskTitle))]
                            ),
                            _vm._v(" "),
                            _vm.selectedTaskIsTask
                              ? _c("studip-icon", {
                                  staticClass: "check",
                                  attrs: {
                                    shape: "check-circle",
                                    size: "24",
                                  },
                                })
                              : _c("studip-icon", {
                                  staticClass: "unchecked",
                                  attrs: {
                                    shape: "decline-circle",
                                    size: "24",
                                  },
                                }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.selectedTaskParent
                      ? _c(
                          "button",
                          {
                            staticClass: "button",
                            on: {
                              click: function click($event) {
                                return _vm.selectTask(_vm.selectedTaskParent.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$gettext(
                                    "zurück zur übergeordneten Seite"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$gettext("Unterseiten"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "cw-element-selector-list",
                        },
                        [
                          _vm._l(_vm.taskChildren, function (child) {
                            return _c(
                              "li",
                              {
                                key: child.id,
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "cw-element-selector-item",
                                    on: {
                                      click: function click($event) {
                                        return _vm.selectTask(child.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(child.attributes.title) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.taskChildren.length === 0
                            ? _c("li", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Es wurden keine Unterseiten gefunden."
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              : _c("courseware-companion-box", {
                  attrs: {
                    mood: "pointing",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie ein Lernmaterial aus."
                    ),
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "tasksettings",
        fn: function fn() {
          return [
            _vm.selectedTaskIsTask
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("label", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$gettext("Aufgabentitel"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "wizard-required",
                          attrs: {
                            "aria-hidden": "true",
                          },
                        },
                        [_vm._v("*")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.taskTitle,
                            expression: "taskTitle",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "taskTitle",
                          required: "",
                        },
                        domProps: {
                          value: _vm.taskTitle,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.taskTitle = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("span", [_vm._v(_vm._s(_vm.$gettext("Abgabefrist")))]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "wizard-required",
                          attrs: {
                            "aria-hidden": "true",
                          },
                        },
                        [_vm._v("*")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.submissionDate,
                            expression: "submissionDate",
                          },
                        ],
                        attrs: {
                          type: "date",
                          name: "submissionDate",
                        },
                        domProps: {
                          value: _vm.submissionDate,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.submissionDate = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Inhalte ergänzen")) +
                          "\n                "
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.solverMayAddBlocks,
                              expression: "solverMayAddBlocks",
                            },
                          ],
                          staticClass: "size-s",
                          on: {
                            change: function change($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.solverMayAddBlocks = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "true",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("ja")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "false",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("nein")))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _c("courseware-companion-box", {
                  attrs: {
                    mood: "pointing",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie eine Aufgabenvorlage aus."
                    ),
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "targetunit",
        fn: function fn() {
          return [
            _vm.selectedTaskIsTask
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _vm.targetUnits.length !== 0
                      ? _c(
                          "fieldset",
                          {
                            staticClass: "radiobutton-set",
                          },
                          [
                            _vm._l(_vm.targetUnits, function (unit) {
                              var _domProps2

                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedTargetUnit,
                                      expression: "selectedTargetUnit",
                                    },
                                  ],
                                  key: "radio-" + unit.id,
                                  attrs: {
                                    id: "cw-task-dist-target-unit" + unit.id,
                                    type: "radio",
                                    "aria-description":
                                      unit.element.attributes.title,
                                  },
                                  domProps:
                                    ((_domProps2 = {
                                      checked:
                                        unit.id === _vm.selectedTargetUnitId,
                                      value: unit,
                                    }),
                                    (_domProps2["checked"] = _vm._q(
                                      _vm.selectedTargetUnit,
                                      unit
                                    )),
                                    _domProps2),
                                  on: {
                                    change: function change($event) {
                                      _vm.selectedTargetUnit = unit
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    key: "label-" + unit.id,
                                    attrs: {
                                      for: "cw-task-dist-target-unit" + unit.id,
                                    },
                                    on: {
                                      click: function click($event) {
                                        _vm.selectedTargetUnit = unit
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "icon",
                                      },
                                      [
                                        _c("studip-icon", {
                                          attrs: {
                                            shape: "courseware",
                                            size: 32,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(unit.element.attributes.title)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("studip-icon", {
                                      staticClass: "unchecked",
                                      attrs: {
                                        shape: "radiobutton-unchecked",
                                        size: 24,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("studip-icon", {
                                      staticClass: "check",
                                      attrs: {
                                        shape: "check-circle",
                                        size: 24,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _c("courseware-companion-box", {
                          attrs: {
                            mood: "sad",
                            msgCompanion: _vm.$gettext(
                              "Es stehen keine Lernmaterialien zur Verfügung."
                            ),
                          },
                        }),
                  ],
                  1
                )
              : _c("courseware-companion-box", {
                  attrs: {
                    mood: "sad",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie eine Aufgabe aus."
                    ),
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "targetelement",
        fn: function fn() {
          return [
            _vm.selectedTargetUnit && _vm.selectedTaskIsTask
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "fieldset",
                      {
                        staticClass: "radiobutton-set",
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "cw-task-dist-target-element",
                            type: "radio",
                            checked: "",
                            "aria-description": _vm.selectedTargetElementTitle,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            attrs: {
                              for: "cw-task-dist-target-element",
                            },
                            on: {
                              click: function click(e) {
                                return e.preventDefault()
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "icon",
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "content2",
                                    size: "32",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                              },
                              [_vm._v(_vm._s(_vm.selectedTargetElementTitle))]
                            ),
                            _vm._v(" "),
                            _c("studip-icon", {
                              staticClass: "check",
                              attrs: {
                                shape: "check-circle",
                                size: "24",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.selectedTargetElementParent
                      ? _c(
                          "button",
                          {
                            staticClass: "button",
                            on: {
                              click: function click($event) {
                                return _vm.selectTargetElement(
                                  _vm.selectedTargetElementParent.id
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$gettext(
                                    "zurück zur übergeordneten Seite"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$gettext("Unterseiten"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "cw-element-selector-list",
                        },
                        [
                          _vm._l(_vm.targetChildren, function (child) {
                            return _c(
                              "li",
                              {
                                key: child.id,
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "cw-element-selector-item",
                                    on: {
                                      click: function click($event) {
                                        return _vm.selectTargetElement(child.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(child.attributes.title) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.targetChildren.length === 0
                            ? _c("li", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Es wurden keine Unterseiten gefunden."
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.selectedTaskIsTask
              ? _c("courseware-companion-box", {
                  attrs: {
                    mood: "sad",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie eine Aufgabe aus."
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.selectedTargetUnit
              ? _c("courseware-companion-box", {
                  attrs: {
                    mood: "sad",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie ein Lernmaterial als Ziel aus."
                    ),
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "solver",
        fn: function fn() {
          return [
            _vm.selectedTargetElement && _vm.selectedTaskIsTask
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Verteilen an")) +
                          "\n                "
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.taskSolverType,
                              expression: "taskSolverType",
                            },
                          ],
                          on: {
                            change: function change($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.taskSolverType = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "autor",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Studierende")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "group",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Gruppen")))]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.taskSolverType === "autor"
                      ? [
                          _c("courseware-companion-box", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.autor_members.length === 0,
                                expression: "autor_members.length === 0",
                              },
                            ],
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Es wurden keine Studierenden in dieser Veranstaltung gefunden."
                              ),
                              mood: "pointing",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.autor_members.length > 0,
                                  expression: "autor_members.length > 0",
                                },
                              ],
                              staticClass: "default",
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bulkSelectAutors,
                                          expression: "bulkSelectAutors",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        "aria-label": _vm.$gettext(
                                          "Alle Studierende auswählen"
                                        ),
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.bulkSelectAutors
                                        )
                                          ? _vm._i(_vm.bulkSelectAutors, null) >
                                            -1
                                          : _vm.bulkSelectAutors,
                                      },
                                      on: {
                                        change: function change($event) {
                                          var $$a = _vm.bulkSelectAutors,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false

                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)

                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.bulkSelectAutors =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.bulkSelectAutors = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.bulkSelectAutors = $$c
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(_vm._s(_vm.$gettext("Name"))),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.autor_members, function (user) {
                                  return _c(
                                    "tr",
                                    {
                                      key: user.user_id,
                                    },
                                    [
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedAutors,
                                              expression: "selectedAutors",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            "aria-label":
                                              _vm.$gettextInterpolate(
                                                _vm.$gettext(
                                                  "%{userName} auswählen"
                                                ),
                                                {
                                                  userName: user.formattedname,
                                                }
                                              ),
                                          },
                                          domProps: {
                                            value: user.user_id,
                                            checked: Array.isArray(
                                              _vm.selectedAutors
                                            )
                                              ? _vm._i(
                                                  _vm.selectedAutors,
                                                  user.user_id
                                                ) > -1
                                              : _vm.selectedAutors,
                                          },
                                          on: {
                                            change: function change($event) {
                                              var $$a = _vm.selectedAutors,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false

                                              if (Array.isArray($$a)) {
                                                var $$v = user.user_id,
                                                  $$i = _vm._i($$a, $$v)

                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedAutors =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedAutors = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectedAutors = $$c
                                              }
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(user.formattedname)),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.taskSolverType === "group"
                      ? [
                          _c("courseware-companion-box", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.groups.length === 0,
                                expression: "groups.length === 0",
                              },
                            ],
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Es wurden keine Gruppen in dieser Veranstaltung gefunden."
                              ),
                              mood: "pointing",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.groups.length > 0,
                                  expression: "groups.length > 0",
                                },
                              ],
                              staticClass: "default",
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bulkSelectGroups,
                                          expression: "bulkSelectGroups",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        "aria-label": _vm.$gettext(
                                          "Alle Gruppen auswählen"
                                        ),
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.bulkSelectGroups
                                        )
                                          ? _vm._i(_vm.bulkSelectGroups, null) >
                                            -1
                                          : _vm.bulkSelectGroups,
                                      },
                                      on: {
                                        change: function change($event) {
                                          var $$a = _vm.bulkSelectGroups,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false

                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)

                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.bulkSelectGroups =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.bulkSelectGroups = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.bulkSelectGroups = $$c
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(_vm._s(_vm.$gettext("Gruppenname"))),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.groups, function (group) {
                                  return _c(
                                    "tr",
                                    {
                                      key: group.id,
                                    },
                                    [
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedGroups,
                                              expression: "selectedGroups",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            "aria-label":
                                              _vm.$gettextInterpolate(
                                                _vm.$gettext(
                                                  "%{groupName} auswählen"
                                                ),
                                                {
                                                  groupName: group.name,
                                                }
                                              ),
                                          },
                                          domProps: {
                                            value: group.id,
                                            checked: Array.isArray(
                                              _vm.selectedGroups
                                            )
                                              ? _vm._i(
                                                  _vm.selectedGroups,
                                                  group.id
                                                ) > -1
                                              : _vm.selectedGroups,
                                          },
                                          on: {
                                            change: function change($event) {
                                              var $$a = _vm.selectedGroups,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false

                                              if (Array.isArray($$a)) {
                                                var $$v = group.id,
                                                  $$i = _vm._i($$a, $$v)

                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedGroups =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedGroups = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectedGroups = $$c
                                              }
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(group.name))]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.selectedTaskIsTask
              ? _c("courseware-companion-box", {
                  attrs: {
                    mood: "sad",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie eine Aufgabe aus."
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.selectedTargetElement
              ? _c("courseware-companion-box", {
                  attrs: {
                    mood: "sad",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie eine Seite aus."
                    ),
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }